import { render, staticRenderFns } from "./UaParser.vue?vue&type=template&id=033398f2"
import script from "./UaParser.vue?vue&type=script&lang=js"
export * from "./UaParser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports